/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
setTimeout(() => {
  cambiadorVat();
  function cambiadorVat() {
    const vatChanger = document.querySelector('#vat-changer');
    if(!vatChanger) return;
    
    vatChanger.style.backgroundColor = '#006280';
    const lineTableCart = document.querySelectorAll('.line-item--stack');

      vatChanger.addEventListener('click', () => {
        addVatCollection();
        addVatCart();
      });
    
      function addVatCollection() {
        const prices = document.querySelectorAll('.price');
        // VAT ON
        if(vatChanger.textContent === 'VAT EXCLUDED') {
            vatChanger.textContent = 'VAT INCLUDED';
           
          
            prices.forEach(precioOriginal => {
              const precioNumber = Number(precioOriginal.textContent.replace('€', '').replace(',', '.'));
              const numberWithVat = precioNumber * 1.21;
              precioOriginal.innerHTML = `€${numberWithVat.toFixed(2).replace('.', ',')}`;
          });
        // VAT OFF
        } else {
           vatChanger.textContent = 'VAT EXCLUDED';
          
            prices.forEach(precioOriginal => {
              const precioNumber = Number(precioOriginal.textContent.replace('€', '').replace(',', '.'));
              const numberWithVat = precioNumber / 1.21;
              precioOriginal.innerHTML = `€${numberWithVat.toFixed(2).replace('.', ',')}`;
          });
        }
      }
      function addVatCart() {
        // VAT ON
        if(vatChanger.textContent === 'VAT INCLUDED') {
            lineTableCart.forEach(productCart => {
              const precioOriginalCart = Number(productCart.children[2].firstElementChild.textContent.replace('€', '').replace(',', '.'));
              const numberWithVatCart = precioOriginalCart * 1.21;
    
              const divInsertPrice = productCart.children[2].firstElementChild;
    
              divInsertPrice.innerHTML = `€${numberWithVatCart.toFixed(2)}`;
          });
        // VAT OFF
        } else {
            lineTableCart.forEach(productCart => {
              const precioOriginalCart = Number(productCart.children[2].firstElementChild.textContent.replace('€', '').replace(',', '.'));
              const numberWithVatCart = precioOriginalCart / 1.21;
    
              const divInsertPrice = productCart.children[2].firstElementChild;
    
              divInsertPrice.innerHTML = `€${numberWithVatCart.toFixed(2)}`;
          });
        }
      }
    }
  
}, "3000");



let apiEndpoint = 'https://itech-parts-pt5ih.ondigitalocean.app';

function sendRegistrationEmails(formData) {
  if (typeof emailjs === "undefined") {
    console.warn("EmailJS not loaded");
    return Promise.resolve();
  }

  var emailConfig = {
    serviceId: "service_6wekoyo",
    adminTemplateId: "template_zkhlsx7",
    customerTemplateId: "template_dbn4q6g",
    adminEmail: "info@itechparts.nl"
  };

  var firstName = formData.get("customer[first_name]") || "";
  var lastName = formData.get("customer[last_name]") || "";
  var customerEmail = formData.get("customer[email]") || "";
  var customerName = (firstName + " " + lastName).trim();

  var params = {
    admin_email: emailConfig.adminEmail,
    to_email: customerEmail,

    customer_email: customerEmail,
    customer_name: customerName,
    first_name: firstName,
    last_name: lastName,

    company: formData.get("address[company]") || "",
    phone: formData.get("address[phone]") || "",
    address1: formData.get("address[address1]") || "",
    address2: formData.get("address[address2]") || "",
    country: formData.get("address[country]") || "",
    province: formData.get("address[province]") || "",
    city: formData.get("address[city]") || "",
    zip: formData.get("address[zip]") || "",

    vat: formData.get("custom[vat]") || "",
    accepts_marketing: formData.get("custom[accepts_marketing]") || "false",
    terms: formData.get("customer[terms]") || "false",
    language: formData.get("custom[language]") || "en"
  };

  return Promise.allSettled([
    emailjs.send(emailConfig.serviceId, emailConfig.adminTemplateId, params),
    emailjs.send(emailConfig.serviceId, emailConfig.customerTemplateId, params)
  ])
    .then(function (results) {
      console.log("Email notification results:", results);
    })
    .catch(function (error) {
      console.warn("Email failed, but registration was submitted:", error);
    });
}


function handleCustomerAdditionalTaxSubmit(e) {
  e.preventDefault();
  e.stopPropagation();
  let line_items = [];
  let cartData = {};
  const { customer } = JSON.parse(document.querySelector('[data-customer-json]').innerHTML)

  fetch('/cart.js').then(function (res) {
    return res.json();
  }).then(function ({ items }) {
    for (var i = 0; i < items.length; i++) {
      const { variant_id, quantity, final_price, properties } = items[i];
      let propertiesArray = [];

      if (properties != null) {
        for (const [key, value] of Object.entries(properties)) {
          propertiesArray.push({
            key: value
          })
        }
      }

      line_items.push({
        variant_id,
        quantity,
        "price_single": final_price,
        "properties": propertiesArray
      });
    }

    cartData.line_items = line_items;
    cartData.customer = customer;

    fetch(apiEndpoint + '/api/addTax', {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify(cartData),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function (response) {
      return response.json();
    }).then(function (res) {
      location.href = res.url + '?locale=' + Shopify.locale;
    }).catch(function (error) {
      console.log('catch error', error);
    })
  });
}

document.querySelectorAll('.js-req-checkout').forEach(function (checkoutButton) {
  checkoutButton.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    handleCustomerAdditionalTaxSubmit(event)
  });
});
/*
function isCookieSet(value) {
  return document.cookie.split(';').some(function (item) {
    return item.trim().indexOf(value) === 0
  })
}
*/
function setPriceVatVisibility(value) {
  const date = new Date(
    new Date().getTime() + 1000 * 60 * 60 * 24
  );
  if (value) {
    // we're overwriting the value
    document.querySelector('body').setAttribute("data-prices-with-vat", value);
    cookies.setCookie("vat_price_visibility", value, { expires: date });
  } else {
    // we're loading the default or setting it if it's not there
    if (cookies.getCookie("vat_price_visibility")) {
      document.querySelector('body').setAttribute("data-prices-with-vat", cookies.getCookie("vat_price_visibility"));
      document.querySelector('#vat-prices-selected').value = cookies.getCookie("vat_price_visibility");
    } else {
      cookies.setCookie("vat_price_visibility", document.querySelector('#vat-prices-selected').value, { expires: date });
      document.querySelector('body').setAttribute("data-prices-with-vat", document.querySelector('#vat-prices-selected').value)
    }
  }
}
if (document.querySelector('#vat-prices-selected')) {
  document.querySelector('#vat-prices-selected').addEventListener('change', function (e) {
    setPriceVatVisibility(e.target.value);
  });
  setPriceVatVisibility();
}

var registerForm = document.querySelector('.js-register-form');

if (registerForm) {
  var formContainer = registerForm.querySelector('.register-form__inner')
  var formSubmitBtn = registerForm.querySelector('.register-form__submit')
  var languageInput = registerForm.querySelector('[name="custom[language]"]')

  if (languageInput) {
    function handleWeglotLang() {
      if (typeof window.Weglot !== 'undefined') {
        const langCode = window.Weglot.getCurrentLang() || 'en'
        console.log(window.Weglot.getCurrentLang())
        languageInput.value = langCode
      } else {
        setTimeout(handleWeglotLang, 250)
      }
    }

    handleWeglotLang();
  }

  registerForm.querySelectorAll('select[name="address[country]"]').forEach(element => {
    var id = element.id
    var province = registerForm.querySelector('select[name="address[province]"]')
    var provinceID = province.id
    var provinceHolderID = province.closest('.form__input-wrapper').id

    return new Shopify.CountryProvinceSelector(id, provinceID, {
      hideElement: provinceHolderID
    })
  })

  var vatCheckbox = registerForm.querySelector('#show-vat')
  var vatField = registerForm.querySelector('#register-vat')
  var vatFieldContainer = registerForm.querySelector('#vat-field-container')
  var validateVatBtn = registerForm.querySelector('.js-validate-vat')
  var vatErrorMessage = registerForm.querySelector('.register-form__vat-error')

  vatCheckbox.addEventListener('change', function () {
    if (this.checked) {
      vatFieldContainer.classList.add('js-active')
    } else {
      vatFieldContainer.classList.remove('js-active')
    }
  })

  vatField.addEventListener('change', function (event) {
    validateVatBtn.disabled = false
    validateVatBtn.classList.remove('js-success')
    validateVatBtn.classList.remove('js-error')
  })

  if (validateVatBtn) {
    validateVatBtn.addEventListener('click', function () {
      validateVatBtn.classList.add('js-loading')
      validateVatBtn.disabled = true

      validateVat(vatField.value)
        .then(function (res) {
          console.log(res)
          validateVatBtn.classList.remove('js-loading')

          if (!res.isValid || !res.isValidFormat) {
            validateVatBtn.classList.add('js-error')
          } else if (res.isValid) {
            validateVatBtn.classList.add('js-success')
          }
        })
        .catch(function (error) {
          console.log('catch error', error);
        })
    })
  }

  var checkboxGroups = registerForm.querySelectorAll('.js-checkbox-group.js-required')

  checkboxGroups.forEach(function (group) {
    initCheckboxValidation(group);
  })

  registerForm.addEventListener('submit', function (event) {
    event.preventDefault()


    if (languageInput) {
      handleWeglotLang();
    }

    if (!vatCheckbox.checked) {
      submitRequest()
      return
    }

    validateVat(vatField.value)
      .then(function (res) {
        if (!res.isValid || !res.isValidFormat) {
          validateVatBtn.classList.add('js-error')
          vatErrorMessage.style.display = 'block';

          vatCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });

          return
        }

        submitRequest()
      })
      .catch(function (error) {
        console.log('catch error', error);
      })

    function submitRequest() {
      var formData = new FormData(event.target);

      let formController = 'registerForm'

      if (event.target.classList.contains('js-register-form--update')) {
        formController = 'updateForm'
      }

      fetch(`${apiEndpoint}/api/${formController}`, {
        method: "POST",
        credentials: "same-origin",
        body: formData,
        headers: {
          "ContentType": "multipart/form-data"
        }
      }).then((response) => {
        if (response.ok) return response.json();

        return response.text().then(response => { throw new Error(response) })
      })
        .then((data) => {
          if (formController == 'registerForm') {
            sendRegistrationEmails(formData);
          }

          if (registerForm.getAttribute('data-redirect') && registerForm.getAttribute('data-redirect') !== "") {
            const redirectURL = registerForm.getAttribute('data-redirect');
            window.open(redirectURL, "_self")
          } else {
            if (formController == 'registerForm') {
              var successMessage = registerForm.querySelector('.register-form__message--success')

              formContainer.style.display = 'none'
              successMessage.style.display = 'block'

              successMessage.scrollIntoView({ behavior: 'instant', block: 'center' });
            } else {
              formSubmitBtn.classList.remove('js-loading')
              formSubmitBtn.classList.add('js-success')
            }
          }

        }).catch((error) => {
          console.log(error)

          if (formController == 'registerForm') {
            var errorMessage = registerForm.querySelector('.register-form__message--error')

            formContainer.style.display = 'none'
            errorMessage.style.display = 'block'
            errorMessage.scrollIntoView({ behavior: 'instant', block: 'center' });
          } else {
            formSubmitBtn.classList.remove('js-loading')
            formSubmitBtn.classList.add('js-error')

            var errorMessage = registerForm.querySelector('.register-form__submit-error')
            errorMessage.style.display = 'block'
            errorMessage.scrollIntoView({ behavior: 'instant', block: 'center' });
          }
        });
    }
  })


  function validateVat(vatNumber) {
    return fetch(`${apiEndpoint}/api/validateVat`, {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({
        vat: vatNumber
      }),
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      if (response.ok) {
        return response.json()
      }

      return Promise.reject(Error('error'))
    }).catch(error => {
      return Promise.reject(Error(error.message))
    })
  }

  function initCheckboxValidation(group) {
    var checkboxes = group.querySelectorAll('input[type=checkbox]');
    var checkboxLength = checkboxes.length;
    var firstCheckbox = checkboxLength > 0 ? checkboxes[0] : null;

    if (firstCheckbox) {
      for (let i = 0; i < checkboxLength; i++) {
        checkboxes[i].addEventListener('change', function () {
          var errorMessage = !isChecked(checkboxLength, checkboxes) ? 'At least one checkbox must be selected.' : '';
          firstCheckbox.setCustomValidity(errorMessage);
        });
      }

      isChecked(checkboxLength, checkboxes)

      var errorMessage = !isChecked(checkboxLength, checkboxes) ? 'At least one checkbox must be selected.' : '';
      firstCheckbox.setCustomValidity(errorMessage);
    }
  }

  function isChecked(checkboxLength, checkboxes) {
    for (let i = 0; i < checkboxLength; i++) {
      if (checkboxes[i].checked) return true;
    }

    return false;
  }
}

const headerDropdowns = document.querySelectorAll('.nav-bar .desktop-menu--wrapper')

if (headerDropdowns.length) {
  headerDropdowns.forEach(function (element, index) {
    const dropdownColumnsLength = element.querySelectorAll('.navigation__item').length

    if (dropdownColumnsLength === 1) {
      element.closest('.nav-bar__item').classList.add('js-single-column')
    }
  })
}
/*
const openRegisterPopup = document.querySelectorAll('.js-open-register-popup')

if (openRegisterPopup.length) {
  openRegisterPopup.forEach(function (element, index) {
    element.addEventListener('click', function (event) {
      event.preventDefault()

      document.querySelector('.js-register-popup').classList.add('js-active')
    })
  })
}

const closeRegisterPopup = document.querySelectorAll('.js-close-register-popup')

if (closeRegisterPopup.length) {
  closeRegisterPopup.forEach(function (element, index) {
    element.addEventListener('click', function (event) {
      event.preventDefault()

      element.closest('.js-register-popup').classList.remove('js-active')
    })
  })
}
*/
// Collection page: translations for filter app
const gfProducts = document.querySelector('.collection__dynamic-part');
function stockMessageUpdate() {
  const productItems = document.querySelectorAll('#gf-products .product-item');

  productItems.forEach(item => {
    const productAvailabilityItem = item.querySelector('.product-form__availability');
    const productAvailabilityMessage = productAvailabilityItem && productAvailabilityItem.querySelector('.product-form__availability-message');
    const productStock = productAvailabilityItem && productAvailabilityItem.getAttribute('data-product-stock');
    if (productAvailabilityMessage) {
      if (productStock > 100) {
        productAvailabilityMessage.innerText = window.languages.inStockHigh;
      } else if (productStock > 10) {
        productAvailabilityMessage.innerText = window.languages.inStockMedium;
      } else if (productStock > 0) {
        productAvailabilityMessage.innerText = window.languages.inStockLow;
      } else {
        productAvailabilityMessage.innerText = window.languages.productFormSoldOut;
      }
    }
  })
}

let observer = new MutationObserver((changes) => {
  if (changes.some(change => change.target.id === 'gf-products')) {
    stockMessageUpdate();
  }

  if(changes.some(change => change.target.classList.contains('gf-filter-contents'))) {
    const productGroupFilterElem = document.querySelector('.gf-option-block--productGroup');
    const topFilterElem = document.querySelector('.gf-filter-contents--top');
    if (productGroupFilterElem) {
      observer.disconnect();
      topFilterElem.innerHTML = productGroupFilterElem.outerHTML;
    }
  }

  observer.observe(gfProducts, {
    attributes: true,
    childList: true,
    subtree: true
  });
});

if(gfProducts) {
  observer.observe(gfProducts, {
    attributes: true,
    childList: true,
    subtree: true
  });
}

const mobileFiltersObserver = new MutationObserver((changes) => {
  if(changes.some(change => change.target.id === 'gf-grid')) {
    if (document.querySelector('.gf-filter-contents--top')) {
      mobileFiltersObserver.disconnect();
      initTopFiltersListener();
    }
  }
})

if (document.querySelector('body.template-collection')) {
  mobileFiltersObserver.observe(document.querySelector('body.template-collection'), {
    childList: true,
    subtree: true
  });
}

function initTopFiltersListener() {
  document.querySelector('.gf-filter-contents--top').addEventListener('click', (e) => {
    if (e.target.closest('a')) {
      e.target.closest('a').classList.toggle('checked')
    }
  })
}

// Updating the RMA language depending on the Weglot language
function updateLinkRMA() {
  const weglotLanguage = document.querySelector('.weglot-container .wgcurrent').getAttribute('data-l');
  const rmaButton = document.querySelector('.order-foot__rma-button');
  
  if(rmaButton) {
    const orderToken = rmaButton.dataset.orderToken;
    const customerEmail = rmaButton.dataset.customerEmail;
    rmaButton.setAttribute('href', `https://rma.4phones.eu?token=${orderToken}&email=${customerEmail}&lang=${weglotLanguage}`);
  }
}

let rmaObserver = new MutationObserver(updateLinkRMA);

window.addEventListener('DOMContentLoaded', () => {
  const weglotLanguageEl = document.querySelector('.weglot-container .wgcurrent')
  if (weglotLanguageEl) {
    rmaObserver.observe(weglotLanguageEl, {
      attributes: true
    });
    updateLinkRMA();
  }
})


// Updating the Wholesale Cart Save app's page layout
let saveCartAppObserver = new MutationObserver(() => {
  observer.disconnect();

  const addToCartBtn = document.querySelector('.aod_btn.btn-success');
  const addNewProductBtn = document.querySelector('.aod_add_new_prd_btn');
  const row = addNewProductBtn.closest('.row');
  const mainRow = addNewProductBtn.closest('.flex-row-reverse');
  const subtotalText = document.querySelector('.aodsubtotalText');

  subtotalText.innerHTML = "MY SAVED CART:";
  row.insertBefore(addToCartBtn, addNewProductBtn);
  mainRow.insertBefore(subtotalText, row);
  row.style.flexDirection = 'row-reverse';
  mainRow.style.justifyContent = 'space-between';
  mainRow.classList.remove('flex-row-reverse');
});

window.addEventListener('DOMContentLoaded', () => {
  const saveCartAppLoader = document.querySelector('#aod_loader');

  if(saveCartAppLoader){
    saveCartAppObserver.observe(saveCartAppLoader, {
      attributes: true
    });
  }
})
